import React from 'react'
import {
  Checkbox,
  FormGroup,
  FormControlLabel,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material'
import { useStore } from '../../Store'
import styled from '@emotion/styled'

const DialogButton = styled(Button)(({ theme, myColor }) => {
  return {
    color:
      myColor === 'primary'
        ? theme.palette.text.action
        : theme.palette.secondary.main,
  }
})

export default function TermsAndCondition({ onAccept, serviceType }) {
  const { setTermsDialog, termsOpen } = useStore((state) => ({
    setTermsDialog: state.setTermsDialog,
    termsOpen: state.termsOpen,
  }))
  const [state, setState] = React.useState({
    actionTaken: false,
    error: false,
  })

  let serviceAgreementLink = ''
  const waiverAgreementLink =
    'https://terms-and-conditions-documents.s3.amazonaws.com/CST_WAIVER_AGRMT_ONLINE.pdf'

  const { actionTaken, error } = state

  switch (serviceType) {
    case 'MX':
      serviceAgreementLink =
        'https://terms-and-conditions-documents.s3.amazonaws.com/CST_MX+AIRSPACE_AGRMT_ONLINE.pdf'
      break
    case 'COF':
      serviceAgreementLink =
        'https://terms-and-conditions-documents.s3.us-east-1.amazonaws.com/CST_COF_AGRMT_ONLINE.pdf'
      break
    case 'BOE':
      serviceAgreementLink =
        'https://terms-and-conditions-documents.s3.amazonaws.com/CST_BOE_AGRMT_ONLINE.pdf'
      break
    default:
      break
  }

  const handleChange = (event) => {
    setState({
      [event.target.name]: event.target.checked,
      error: !event.target.checked,
    })
  }

  const handleClose = () => {
    setTermsDialog(false)
  }

  const handleConfirmation = () => {
    if (actionTaken) {
      onAccept()
      setTermsDialog(false)
    } else {
      setState({ ...state, error: true })
    }
  }

  return (
    <div>
      <Dialog
        open={!!termsOpen}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="md"
        fullWidth
        sx={{ '& .MuiDialog-paper': { backgroundColor: '#F7F8FA' } }} //C8C8C8
      >
        <DialogTitle id="alert-dialog-title">Terms and Conditions</DialogTitle>
        <DialogContent>
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  sx={{ color: 'black' }}
                  checked={actionTaken}
                  onChange={handleChange}
                  name="actionTaken"
                />
              }
              label={
                <DialogContentText
                  id="alert-dialog-description"
                  style={{ margin: 0, color: 'black' }}
                >
                  I have read the{' '}
                  <a
                    href={serviceAgreementLink}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Service Agreement
                  </a>{' '}
                  and{' '}
                  <a
                    href={waiverAgreementLink}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Liability Waiver
                  </a>
                </DialogContentText>
              }
            />
            {error && (
              <DialogContentText id="alert-dialog-description" color="error">
                No action has been taken. Check the field above to proceed
              </DialogContentText>
            )}
          </FormGroup>
        </DialogContent>
        <DialogActions>
          <DialogButton onClick={handleClose} myColor="secondary">
            Cancel
          </DialogButton>
          <DialogButton
            onClick={handleConfirmation}
            myColor="primary"
            autoFocus
          >
            Confirm
          </DialogButton>
        </DialogActions>
      </Dialog>
    </div>
  )
}
